// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3BBLI","box":"WorkspacesBox_box__36_ul","node":"WorkspacesBox_node__QEt1v"};